export enum MessageToken {
  CLIENT_FIRST_NAME = 'client_first_name',
  NEXT_SESSION_DATETIME = 'next_session_datetime',
  BOOKING_LINK = 'booking_link',
  DATE_TIME_72_HOURS = 'date_time_72_hours',
}
